var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2 2.7C10.5924 2.7 10.1 2.20751 10.1 1.6C10.1 0.992487 10.5924 0.5 11.2 0.5H16.7C17.3075 0.5 17.8 0.992487 17.8 1.6V7.1C17.8 7.70751 17.3075 8.2 16.7 8.2C16.0924 8.2 15.6 7.70751 15.6 7.1V4.25563L10.8778 8.97782C10.4482 9.40739 9.75171 9.40739 9.32213 8.97782L6.79995 6.45563L2.07777 11.1778C1.64819 11.6074 0.95171 11.6074 0.522134 11.1778C0.092557 10.7482 0.092557 10.0518 0.522134 9.62218L6.02213 4.12218C6.45171 3.69261 7.14819 3.69261 7.57777 4.12218L10.1 6.64437L14.0443 2.7H11.2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrending);
export default __webpack_public_path__ + "static/media/trending.c48f84002cac62dc974da4abb4eb690e.svg";
export { ForwardRef as ReactComponent };